import React from 'react';
import { colors } from '../constants';

const PendingIcon = (_props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <defs>
      <path
        id="a"
        d="M10 18.857a8.857 8.857 0 1 0 0-17.714 8.857 8.857 0 0 0 0 17.714zM10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zM6 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#F2CD00" fillRule="nonzero" xlinkHref="#a" />
      <g fill="#909090" mask="url(#b)">
        <path d="M0 0h20v19.989H0z" />
      </g>
    </g>
  </svg>
);

PendingIcon.defaultProps = {
  color: colors.mediumGrey,
  width: 20,
  height: 20,
};

export default PendingIcon;
